function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "a",
  cx: 6.525,
  cy: 6.491,
  rx: 6.525,
  ry: 6.491
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  stroke: "#4F4D4C",
  strokeWidth: 3,
  d: "M2 48.431h87V122H2z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#4F4D4C",
  strokeWidth: 3,
  d: "M2 109.017h87M69.425 49.603V25.802C69.425 12.656 58.713 2 45.5 2 32.287 2 21.575 12.656 21.575 25.802v23.801"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.975 65.742)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FC0",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.525,
  cy: 6.491,
  stroke: "#4F4D4C",
  strokeWidth: 3,
  rx: 8.025,
  ry: 7.991
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#4F4D4C",
  strokeWidth: 3,
  d: "M45.5 80.888v17.31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-19-2h128v128H-19z"
}));

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 124,
    viewBox: "0 0 91 124",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.1b821aad.svg";
export { ForwardRef as ReactComponent };